

.group {

    margin: 1.5em 0;
    padding: 1em 1.5em;
    background-color: white;
    border-radius: var(--border-radius);

}

.wrapper {

  display: flex;
  align-items: start;

  .content {
    flex-grow: 1;
    display: flex;
    gap: 1.5em;
    flex-direction: column;

    h2 {
      padding: 0.5em 0;

      //[id]::before {
      //  content: '';
      //  display: block;
      //  height:      75px;
      //  margin-top: -75px;
      //  visibility: hidden;
      //}
      //&:before {
      //  content: '';
      //  //margin-top: -200px;
      //  //height: 200px;
      //  width: 10px;
      //  height: 10px;
      //  background-color: red;
      //  display: block;
      //  position:absolute;
      //  top: -300px;
      //  z-index: 10000;
      //}


      & > a[id] {
        display: block;
        top: calc(var(--header-height) * -1 - 1em);
        position: relative;
        width: 1px;
        height: 1px;
        background: red;
        z-index: 10000000;
        left: 0;
      }
    }
  }
}


.alert {
  border: 2px solid #00b45d;
  padding: 1em;
  margin-bottom: 1em;
}